import React from 'react';

import './ManualEntryStageOptions.scss';

import RadioButton from '../../../components/Shared/RadioButton/RadioButton';
import { EVERIFY_TEST_MODES } from '../../../settings/settings';

const ManualEntryStageOptions = ({
  manualBankSimulationMode,
  updateManualBankSimulationMode,
}) => (
  <div className="manaul-entry-stage-options-simulator-options">
    <div className="manaul-entry-stage-options-prod-warning">
      You are not in PRODUCTION
    </div>
    <div>Test eVerify by choosing one of the options below:</div>
    <div className="manaul-entry-stage-options-tester-container">
      <RadioButton
        ariaLabel="Everify Pass"
        checked={manualBankSimulationMode === EVERIFY_TEST_MODES.PASSED}
        id="everify-passed"
        labelText="PASS"
        name="manualBankSimulationMode"
        onClick={updateManualBankSimulationMode}
        value={EVERIFY_TEST_MODES.PASSED}
      />

      <RadioButton
        ariaLabel="Everify Fail ID"
        checked={
          manualBankSimulationMode === EVERIFY_TEST_MODES.INDIVIDUAL_NOT_FOUND
        }
        id="everify-id-not-found"
        labelText="FAIL - ID Unknown"
        name="manualBankSimulationMode"
        onClick={updateManualBankSimulationMode}
        value={EVERIFY_TEST_MODES.INDIVIDUAL_NOT_FOUND}
      />

      <RadioButton
        ariaLabel="Everify Fail App"
        checked={
          manualBankSimulationMode === EVERIFY_TEST_MODES.INTERNAL_APP_ERROR
        }
        id="everify-app-error"
        labelText="FAIL - App Error"
        name="manualBankSimulationMode"
        onClick={updateManualBankSimulationMode}
        value={EVERIFY_TEST_MODES.INTERNAL_APP_ERROR}
      />

      <RadioButton
        ariaLabel="Everify Fail Answers"
        checked={
          manualBankSimulationMode === EVERIFY_TEST_MODES.FAILED_IAUTH_QUESTIONS
        }
        id="everify-fail-questions"
        labelText="FAIL - Incorrect Answers"
        name="manualBankSimulationMode"
        onClick={updateManualBankSimulationMode}
        value={EVERIFY_TEST_MODES.FAILED_IAUTH_QUESTIONS}
      />

      <RadioButton
        ariaLabel="Everify Fail Attempts"
        checked={
          manualBankSimulationMode ===
          EVERIFY_TEST_MODES.DENIAL_IAUTH_FAILED_TOO_RECENTLY
        }
        id="everify-fail-too-recent"
        labelText="FAIL - Too Many Attempts"
        name="manualBankSimulationMode"
        onClick={updateManualBankSimulationMode}
        value={EVERIFY_TEST_MODES.DENIAL_IAUTH_FAILED_TOO_RECENTLY}
      />

      <RadioButton
        ariaLabel="Everify Fail Time"
        checked={
          manualBankSimulationMode === EVERIFY_TEST_MODES.TRANSACTION_EXPIRED
        }
        id="everify-fail-transactions-expired"
        labelText="FAIL - Time Expired"
        name="manualBankSimulationMode"
        onClick={updateManualBankSimulationMode}
        value={EVERIFY_TEST_MODES.TRANSACTION_EXPIRED}
      />
    </div>
  </div>
);

export default ManualEntryStageOptions;
